import React from 'react';
import {
  Label, Input, FormGroup, Col,
} from 'reactstrap';
import styled from 'styled-components';

const ErrMsg = styled.small`
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
`;

const RadioGroup = ({
  meta: { touched, error, warning },
  input: { onChange },
  label,
  defaultGender,
}) => (
  <FormGroup row>
    <Col sm="2">
      {label}
    </Col>
    <Col sm="5">
      <FormGroup check>
        <Label check>
          <Input
            onChange={onChange}
            type="radio"
            name="gender"
            value="male"
            defaultChecked={defaultGender === 'male'}
          />
                Male
        </Label>
      </FormGroup>
    </Col>
    <Col sm="5">
      <FormGroup check>
        <Label check>
          <Input
            onChange={onChange}
            type="radio"
            name="gender"
            value="female"
            defaultChecked={defaultGender === 'female'}
          />

                Female
        </Label>
      </FormGroup>
    </Col>
    {touched && ((error && <ErrMsg>{error}</ErrMsg>) || (warning && <span>{warning}</span>))}
  </FormGroup>
);

export default RadioGroup;
